<!--
 * @Descripttion: 项目根组件
 * @Author: congz
 * @Date: 2020-06-04 11:22:40
 * @LastEditors: congz
 * @LastEditTime: 2020-09-01 14:34:14
--> 

<template>
  <div id="app" name="app">
    <el-container>
      <!-- 顶栏容器 -->

      <el-header v-show="$route.meta.showMenu!==false" style="background-color:var(--color-bg);border-bottom:0;box-shadow:none;">
        <el-menu
          :default-active="activeIndex"
          class="el-menu-demo"
          mode="horizontal"
          active-text-color="#1C2A46"
          background-color="transparent"
          text-color="#2D2D2D"
          router
          style="border-bottom:0;box-shadow:none;"
        >
          <div class="logo">
            <router-link to="/">
              <img src="./assets/imgs/clogo.png" alt />
            </router-link>
          </div>
          <el-menu-item index="/">HOME</el-menu-item>
          <el-menu-item index="/goods">SHOP</el-menu-item>
          <el-menu-item index="/about?id=1">About Me</el-menu-item>
          <el-submenu index="faqs">
            <template slot="title">FAQs</template>
            <el-menu-item index="/faqs?section=shopping">Shopping Information</el-menu-item>
            <el-menu-item index="/about?id=4">Return &amp; Cancellation</el-menu-item>
          </el-submenu>
          <el-menu-item index="/contact">Contact Us</el-menu-item>
          <div class="site-search">
            <el-input
              v-model="search"
              placeholder="Search product..."
              class="site-search-input dark-theme"
              @keyup.enter.native="searchClick"
            >
              <el-button slot="append" icon="el-icon-search" @click="searchClick"></el-button>
            </el-input>
          </div>
          <div class="menu-right">
            <div v-if="!this.$store.getters.getUser" class="menu-auth-wrap">
              <div class="menu-auth-trigger">
                <router-link to="/login" style="color: #000;">Login</router-link>
                <span style="color: #000;">/</span>
                <router-link to="/register" style="color: #000;">Register</router-link>
              </div>
              <div class="menu-auth-panel">
                <div class="auth-tabs">
                  <span class="active">Sign in</span>
                  <router-link to="/register">Create an Account</router-link>
                </div>
                <div class="auth-field">Username or email address</div>
                <el-input size="mini" placeholder="Username or email address"></el-input>
                <div class="auth-field">Password</div>
                <el-input size="mini" type="password" placeholder="Password"></el-input>
                <el-button size="mini" type="primary" class="auth-submit">Log In</el-button>
                <div class="auth-footer">
                  <label><input type="checkbox" /> Remember me</label>
                  <router-link to="/login">Lost your password?</router-link>
                </div>
              </div>
            </div>
            <div v-else class="header-user-con">
              <div class="user-avator">
                <img :src="this.$store.getters.getUser.avatar || 'https://via.placeholder.com/40x40/B9365B/ffffff?text=User'" />
              </div>
              <div class="user-name">
                <el-dropdown>
                  <span class="el-dropdown-link">
                    {{this.$store.getters.getUser.nickname}}
                    <i class="el-icon-caret-bottom"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <router-link to="/center">
                      <el-dropdown-item>Personal Center</el-dropdown-item>
                    </router-link>
                    <a @click="logout">
                      <el-dropdown-item>Logout</el-dropdown-item>
                    </a>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
            </div>
            <router-link class="menu-text" to="/favorite">Wishlist</router-link>
            <router-link :class="getNum > 0 ? 'menu-cart menu-cart-full' : 'menu-cart'" to="/cart">
              Cart
              <span>{{getNum}}</span>
            </router-link>
          </div>
        </el-menu>
      </el-header>

      <!-- 顶栏容器END -->

      <!-- 移动端顶部栏 -->
      <div class="mobile-header" v-show="$route.meta.showMenu!==false">
        <div class="mobile-header-inner">
          <a href="javascript:void(0)" class="mobile-menu" @click.prevent="mobileMenuVisible = true">
            <i class="el-icon-menu"></i>
            <span>Menu</span>
          </a>
          <router-link class="mobile-logo" to="/">
            <img src="./assets/imgs/clogo.png" alt />
          </router-link>
          <router-link class="mobile-cart" to="/cart">
            <i class="el-icon-shopping-cart-full"></i>
            <span v-if="getNum>0" class="badge">{{getNum}}</span>
          </router-link>
        </div>
      </div>
      <!-- 移动端顶部栏END -->

      <!-- 移动端抽屉菜单 -->
      <el-drawer
        :visible.sync="mobileMenuVisible"
        direction="ltr"
        size="80%"
        custom-class="mobile-drawer"
        :with-header="false"
      >
        <div class="mobile-drawer-header">
          <span>Menu</span>
          <i class="el-icon-close" @click="mobileMenuVisible=false"></i>
        </div>
        <div class="mobile-drawer-body">
          <el-input
            v-model="mobileSearch"
            placeholder="Search for products"
            class="mobile-search"
            @keyup.enter.native="mobileSearchClick"
          >
            <el-button slot="append" icon="el-icon-search" @click="mobileSearchClick"></el-button>
          </el-input>
          <div class="drawer-switch">
            <button
              class="switch-btn"
              :class="{active: mobileMenuTab==='collection'}"
              @click="mobileMenuTab='collection'"
            >
              Collection
            </button>
            <button
              class="switch-btn"
              :class="{active: mobileMenuTab==='menu'}"
              @click="mobileMenuTab='menu'"
            >
              Menu
            </button>
          </div>
          <div class="drawer-content">
            <div v-if="mobileMenuTab==='collection'" class="mobile-drawer-section">
              <div class="section-title">Collection</div>
              <ul class="link-list">
                <li v-for="item in shopCategories" :key="item.category_id">
                  <router-link :to="`/goods?categoryID=${item.category_id}`" @click.native="mobileMenuVisible=false">
                    {{item.category_name}}
                  </router-link>
                </li>
              </ul>
            </div>
            <div v-else class="mobile-drawer-section">
              <div class="section-title">Menu</div>
              <ul class="link-list">
                <li><router-link to="/" @click.native="mobileMenuVisible=false">Home</router-link></li>
                <li><router-link to="/about?id=1" @click.native="mobileMenuVisible=false">About Me</router-link></li>
                <li><router-link to="/order" @click.native="mobileMenuVisible=false">My Order</router-link></li>
                <li><router-link to="/favorite" @click.native="mobileMenuVisible=false">Wishlist</router-link></li>
                <li><router-link to="/goods" @click.native="mobileMenuVisible=false">All Products</router-link></li>
              </ul>
            </div>
          </div>
        </div>
      </el-drawer>
      <!-- 移动端抽屉菜单END -->

      <!-- 主要区域容器 -->
      <el-main>
        <keep-alive>
          <router-view :key="key"></router-view>
        </keep-alive>
      </el-main>
      <!-- 主要区域容器END -->

      <!-- 公司信息浮窗（右下角） -->
      <div class="company-fab" v-show="$route.meta.showMenu!==false">
        <transition name="company-card-fade">
          <div v-if="companyCardOpen" class="company-card">
            <div class="company-card-head">
              <div class="company-card-title">
                <span class="company-card-icon">🏢</span>
                <span>Company Information</span>
              </div>
              <i class="el-icon-close company-card-close" @click="companyCardOpen = false"></i>
            </div>
            <div class="company-card-body">
              <div class="company-card-name">CARRIERTAKER LOGISTICS INDIA PRIVATE LIMITED</div>

              <div class="company-card-row">
                <span class="company-card-label">📍 Address</span>
                <span class="company-card-value">
                  305, Third Floor, Adjoining Bank of India, Industrial Area-A, Cheema Chowk, Ludhiana – 141003 (Punjab), India
                </span>
              </div>

              <div class="company-card-row">
                <span class="company-card-label">📞 Mobile</span>
                <a class="company-card-value link" href="tel:+91XXXXXXXXXX">+91 XXXXXXXXXX</a>
              </div>

              <div class="company-card-row">
                <span class="company-card-label">✉️ Email</span>
                <a class="company-card-value link" href="mailto:info@carriertakerstyle.in">info@carriertakerstyle.in</a>
              </div>

              <div class="company-card-row">
                <span class="company-card-label">🌐 Website</span>
                <a class="company-card-value link" href="https://www.carriertakerstyle.in" target="_blank" rel="noopener">www.carriertakerstyle.in</a>
              </div>

              <div class="company-card-row">
                <span class="company-card-label">🕒 Hours</span>
                <span class="company-card-value">Mon–Sat · 10:00 AM – 7:00 PM</span>
              </div>
            </div>
            <div class="company-card-foot">
              <span>Customer support · always here to help</span>
            </div>
          </div>
        </transition>

        <button
          class="company-fab-btn"
          :class="{ 'is-active': companyCardOpen }"
          @click="companyCardOpen = !companyCardOpen"
          :aria-label="companyCardOpen ? 'Hide company info' : 'Show company info'"
        >
          <i :class="companyCardOpen ? 'el-icon-close' : 'el-icon-info'"></i>
          <span class="company-fab-label">Company</span>
        </button>
      </div>
      <!-- 公司信息浮窗END -->

      <!-- 移动端底部TabBar -->
      <div class="mobile-tabbar" v-show="$route.meta.showMenu!==false">
        <router-link to="/goods" class="tab">
          <i class="el-icon-s-goods"></i>
          <span>Shop</span>
        </router-link>
        <router-link to="/favorite" class="tab">
          <i class="el-icon-star-off"></i>
          <span>Wishlist</span>
        </router-link>
        <router-link to="/cart" class="tab">
          <i class="el-icon-shopping-cart-1"></i>
          <span>Cart</span>
          <em v-if="getNum>0" class="dot">{{getNum}}</em>
        </router-link>
        <router-link to="/center" class="tab">
          <i class="el-icon-user"></i>
          <span>My account</span>
        </router-link>
      </div>
      <!-- 移动端底部TabBar END -->

      <!-- 底栏容器 -->
      <el-footer>
        <div class="footer">
          <div class="footer-subscribe-section">
             <div class="subscribe-title">Elegance in Every Thread</div>
             <div class="subscribe-action">
                <button class="subscribe-btn-arrow"><i class="el-icon-right"></i></button>
             </div>
          </div>
          <div class="footer-content">
            <div class="footer-links-group">
              <div class="footer-col">
                <h4>Shop & Information</h4>
                <router-link to="/about?id=1">About Us</router-link>
                <router-link to="/contact">Contact Us</router-link>
                <router-link to="/about?id=6">Terms of Service</router-link>
                <router-link to="/about?id=2">Privacy Policy</router-link>
              </div>
              <div class="footer-col">
                <h4>Help</h4>
                <router-link to="/about?id=3">Shipping & Delivery</router-link>
                <router-link to="/about?id=4">Returns & Exchanges</router-link>
                <router-link to="/about?id=5">Cancel Policy</router-link>
                <router-link to="/faqs">FAQs</router-link>
              </div>
               <div class="footer-col">
                <h4>About Us</h4>
                <router-link to="/about?id=1">Our Story</router-link>
              </div>
            </div>

             <div class="footer-right-promo">
               <h4>Trending This Season</h4>
               <p>Curated ethnic wear for the modern Indian woman</p>
               <div class="footer-promo-links">
                  <router-link to="/goods?categoryID=61">Kurtas &amp; Kurtis <i class="el-icon-right"></i></router-link>
                  <router-link to="/goods?categoryID=63">Sarees <i class="el-icon-right"></i></router-link>
               </div>
            </div>
          </div>
          <div class="footer-copyright">
            Copyright © 2026, CARRIERTAKER LOGISTICS INDIA PRIVATE LIMITED. All Rights Reserved.
          </div>
        </div>
      </el-footer>
      <!-- 底栏容器END -->
    </el-container>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { mapGetters } from 'vuex'
import * as cartsAPI from '@/api/carts'
import * as userAPI from '@/api/users'
import * as categoryAPI from '@/api/categories'

export default {
  beforeUpdate() {
    this.activeIndex = this.$route.path
  },
  data() {
    return {
      activeIndex: '', // 头部导航栏选中的标签
      search: '', // 搜索条件
      shopCategories: [],
      mobileMenuVisible: false,
      mobileSearch: '',
      mobileMenuTab: 'collection',
      companyCardOpen: false // 右下角公司信息浮窗展开状态
    }
  },
  beforeCreate() {
    document.querySelector('body').setAttribute('style', 'background:#F8FAFC')
  },
  created() {
    // 获取浏览器localStorage，判断用户是否已经登录
    userAPI.checkToken(localStorage.getItem('token')).then(res => {
      // 如果已经登录，设置vuex登录状态
      if (res.status == 200) {
        this.setUser(JSON.parse(localStorage.getItem('user')))
      } else {
        localStorage.removeItem('user')
        localStorage.removeItem('token')
      }
    })
    categoryAPI
      .listCategories()
      .then(res => {
        if (res.status === 200) {
          this.shopCategories = res.data
        } else {
          this.notifyError('Failed to obtain classification', res.msg)
        }
      })
      .catch(err => {
        this.notifyError('Failed to obtain classification', err)
      })
  },
  computed: {
    ...mapGetters(['getUser', 'getNum']),
    key() {
      return this.$route.path
    }
  },
  watch: {
    // 获取vuex的登录状态
    getUser: function(val) {
      if (val === '') {
        // 用户没有登录
        this.setShoppingCart([])
      } else {
        // 用户已经登录,获取该用户的购物车信息
        cartsAPI
          .showCarts(val.id)
          .then(res => {
            if (res.status === 200) {
              if (res.data === null) {
                this.setShoppingCart([])
              } else {
                this.setShoppingCart(res.data)
              }
            } else if (res.status === 20001) {
              //token过期，需要重新登录
              this.loginExpired(res.msg)
            } else {
              this.$notify.error({
                title: 'Failed to fetch cart',
                message: res.msg
              })
            }
          })
          .catch(err => {
            return Promise.reject(err)
          })
      }
    }
  },
  methods: {
    ...mapActions(['setUser', 'setShoppingCart']),
    login() {
      this.$router.push({
        name: 'Login'
      })
    },
    // 退出登录
    logout() {
      // 清空本地登录信息
      localStorage.removeItem('user')
      localStorage.removeItem('token')
      // 清空vuex登录信息
      this.setUser('')
      this.$router.push({
        name: 'Home'
      })
      this.notifySucceed('Logged out successfully')
    },
    //重定向
    register() {
      this.$router.push({
        name: 'Register'
      })
    },
    // 点击搜索按钮
    searchClick() {
      if (this.search != '') {
        // 跳转到全部商品页面,并传递搜索条件
        this.$router.push({ path: '/goods', query: { search: this.search } })
        this.search = ''
      }
    },
    mobileSearchClick() {
      if (this.mobileSearch) {
        this.$router.push({ path: '/goods', query: { search: this.mobileSearch } })
        this.mobileSearch = ''
        this.mobileMenuVisible = false
      }
    }
  }
}
</script>

<style>
/* 全局CSS */
* {
  padding: 0;
  margin: 0;
  border: 0;
  list-style: none;
}

.header-user-con {
  display: flex;
  height: 44px;
  align-items: center;
}
.user-name {
  margin-left: 10px;
}
.user-avator img {
  display: block;
  width: 40px;
  height: 40px;
  border-radius: 50%;
}
.el-dropdown-link {
  color: #000;
  cursor: pointer;
}

.el-dropdown-menu__item {
  text-align: center;
}
.el-dropdown-item:hover {
  color: #1C2A46;
}

#app .el-header {
  padding: 0;
  height: 60px !important;
}
#app .el-main {
  min-height: 300px;
  padding: 20px 0 0 0;
  overflow: visible;
}
#app .el-footer {
  padding: 0;
}
a,
a:hover {
  text-decoration: none;
}
/* 全局CSS END */

/* 默认隐藏移动端专用按钮（桌面端不显示） */
.mobile-header,
.mobile-tabbar {
  display: none;
}

/* 顶部导航栏CSS */
/* 顶栏容器CSS */
.el-header {
  height: 60px;
  margin-bottom: 0;
  background-color: #F8FAFC;
  border-bottom: 0;
  position: relative;
  z-index: 100;
}
.el-header .el-menu {
  max-width: 1280px;
  width: 100%;
  margin: 0 auto;
  padding: 0 24px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  background-color: transparent;
  flex-wrap: nowrap;
  border-bottom: 0;
}
.el-menu--horizontal>.el-menu-item.is-active {
  color: #1C2A46;
}
.el-menu--horizontal {
  border-bottom: 0;
}
.el-menu--horizontal > .el-menu-item,
.el-menu--horizontal > .el-submenu .el-submenu__title {
  border-bottom: 0;
}

.el-header .logo {
  height: 60px;
  width: 180px;
  float: left;
  margin-right: 24px;
  flex-shrink: 0;
}
.site-search {
  margin-left: 16px;
  margin-right: auto;
  width: 520px;
  max-width: 42vw;
}
.site-search-input .el-input__inner {
  background-color: #FFFFFF;
  border: 1.5px solid rgba(28, 42, 70, 0.15);
  color: #2D2D2D;
  border-radius: 24px 0 0 24px;
}
.site-search-input .el-input-group__append {
  background-color: #1C2A46;
  border: 1.5px solid #1C2A46;
  border-left: 0;
  border-radius: 0 24px 24px 0;
  padding: 0;
}
.site-search-input .el-input-group__append .el-button {
  background: transparent;
  border: none;
  color: #FFFFFF;
  margin: 0;
  padding: 12px 20px;
}
.site-search-input .el-input-group__append .el-button:hover {
  color: #FFFFFF;
  background-color: #0A1837;
}
.el-menu--horizontal > .el-menu-item,
.el-menu--horizontal > .el-submenu {
  flex-shrink: 0;
}
.el-header .logo img {
  height: 44px;
  margin-top: 8px;
  border-radius: 8px;
  mix-blend-mode: multiply;
}
.menu-right {
  margin-left: auto;
  display: flex;
  align-items: center;
  gap: 16px;
  color: #2D2D2D;
  flex-shrink: 0;
}
.menu-auth-wrap {
  position: relative;
}
.menu-auth-trigger {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  color: #2D2D2D;
  white-space: nowrap;
}
.menu-auth-trigger a {
  color: #1C2A46;
}
.menu-auth-panel {
  position: absolute;
  right: 0;
  top: 34px;
  width: 270px;
  background: #ffffff;
  color: #2f2238;
  border-radius: 6px;
  padding: 14px;
  box-shadow: 0 16px 30px rgba(0, 0, 0, 0.18);
  display: none;
  z-index: 10;
}
.menu-auth-wrap:hover .menu-auth-panel {
  display: block;
}
.auth-tabs {
  display: flex;
  justify-content: space-between;
  font-size: 12px;
  margin-bottom: 10px;
}
.auth-tabs .active {
  font-weight: 600;
  color: #2f2238;
}
.auth-tabs a {
  color: #6d637b;
}
.auth-field {
  font-size: 11px;
  color: #6d637b;
  margin: 8px 0 4px;
}
.auth-submit {
  margin-top: 10px;
  width: 100%;
  background: #1C2A46;
  border-color: #1C2A46;
}
.auth-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 11px;
  color: #6d637b;
  margin-top: 10px;
}
.auth-footer a {
  color: #6d637b;
}
.auth-footer input {
  margin-right: 6px;
}
.menu-text {
  color: #000;
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.4px;
}
.menu-cart {
  position: relative;
  padding-right: 10px;
}
.menu-cart span {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  font-size: 11px;
  font-weight: 700;
  background: #C9D6E8;
  color: #2D2D2D;
  border-radius: 50%;
  margin-left: 8px;
}
.menu-cart.menu-cart-full span {
  box-shadow: 0 0 0 2px #1C2A46;
}

@media (max-width: 1100px) {
  .site-search { display: none; }
}
.menu-cart {
  color: #FFFFFF;
  padding: 10px 18px;
  background: #1C2A46;
  border-radius: 24px;
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 0.2px;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  transition: all 0.25s ease;
}
.menu-cart:hover {
  background: #0A1837;
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(28, 42, 70, 0.35);
  color: #FFFFFF;
}
.menu-cart-full {
  background: #C9D6E8;
  color: #2D2D2D;
}
.el-menu--horizontal > .el-menu-item {
  color: #2D2D2D;
  font-weight: 500;
  letter-spacing: 0.3px;
}
.el-menu--horizontal > .el-menu-item.is-active {
  color: #1C2A46;
}
.el-menu--horizontal > .el-menu-item:not(.is-disabled):hover {
  color: #1C2A46;
}
.el-menu--horizontal > .el-submenu .el-submenu__title {
  color: #2D2D2D;
  font-weight: 500;
  letter-spacing: 0.3px;
}
.el-menu--horizontal > .el-submenu.is-active .el-submenu__title {
  color: #1C2A46;
}
.el-menu--horizontal > .el-submenu:not(.is-disabled):hover .el-submenu__title {
  color: #1C2A46;
}

/* 顶栏容器CSS END */

/* 底栏容器CSS */
.footer {
  width: 100%;
  background: #E4ECF5;
  color: #2D2D2D;
  padding: 60px 0 0;
}
.footer-subscribe-section {
  background: linear-gradient(135deg, #1C2A46 0%, #0A1837 100%);
  padding: 50px 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  max-width: 1280px;
  margin: 0 auto;
  border-radius: 24px 24px 0 0;
  position: relative;
  overflow: hidden;
}
.footer-subscribe-section::before {
  content: '';
  position: absolute;
  top: 0;
  right: 0;
  width: 300px;
  height: 100%;
  background: url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.08'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
}
.subscribe-title {
  font-size: 32px;
  font-weight: 700;
  color: #FFFFFF;
  font-family: 'Georgia', serif;
  letter-spacing: 0.5px;
  position: relative;
  z-index: 1;
}
.subscribe-action {
  display: flex;
  align-items: center;
  position: relative;
  z-index: 1;
}
.subscribe-btn-arrow {
  width: 52px;
  height: 52px;
  border-radius: 50%;
  border: 2px solid #FFFFFF;
  background: transparent;
  color: #FFFFFF;
  font-size: 20px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.25s ease;
}
.subscribe-btn-arrow:hover {
  background: #FFFFFF;
  color: #1C2A46;
  transform: scale(1.05);
}
.footer-content {
  max-width: 1280px;
  margin: 0 auto;
  padding: 60px 24px;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 40px;
}
.footer-links-group {
  flex: 2;
  display: flex;
  justify-content: space-around;
  gap: 60px;
}
.footer-col h4 {
  font-size: 14px;
  font-weight: 700;
  margin-bottom: 20px;
  color: #1C2A46;
  text-transform: uppercase;
  letter-spacing: 1px;
}
.footer-col a {
  display: block;
  color: #6B6B6B;
  font-size: 14px;
  margin-bottom: 12px;
  transition: color 0.2s ease;
}
.footer-col a:hover {
  color: #1C2A46;
}
.footer-right-promo {
  text-align: right;
  max-width: 280px;
}
.footer-right-promo h4 {
  font-size: 16px;
  font-weight: 700;
  color: #1C2A46;
  margin-bottom: 10px;
}
.footer-right-promo p {
  font-size: 13px;
  color: #6B6B6B;
  margin-bottom: 16px;
  line-height: 1.6;
}
.footer-promo-links a {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  font-size: 13px;
  color: #2D2D2D;
  margin-bottom: 10px;
  font-weight: 600;
  text-decoration: none;
  transition: all 0.2s ease;
}
.footer-promo-links a:hover {
  color: #1C2A46;
  transform: translateX(-4px);
}
.footer-promo-links a i {
  margin-left: 8px;
}
.footer-copyright {
    text-align: center;
    padding: 24px 0;
    font-size: 13px;
    color: #9B9B9B;
    border-top: 1px solid rgba(28, 42, 70, 0.1);
    max-width: 1280px;
    margin: 0 auto;
  }
/* 底栏容器CSS END */

/* 移动端适配 */
@media (max-width: 900px) {
  .el-header {
    display: none;
  }
  #app .el-main {
    padding-top: 56px;
    padding-bottom: 64px;
  }
  .mobile-header {
    display: block;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    width: 100vw;
    height: 56px;
    background: linear-gradient(135deg, #1C2A46 0%, #0A1837 100%);
    z-index: 1000;
    border-bottom: 0;
  }
  .mobile-header-inner {
    width: 100%;
    height: 56px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 12px;
    color: #ffffff;
  }
  .mobile-header a {
    color: #ffffff;
    display: flex;
    align-items: center;
    gap: 6px;
  }
  .mobile-logo img {
    height: 34px;
    border-radius: 8px;
  }
  .mobile-cart {
    position: relative;
    margin-right: 28px;
  }
  .mobile-cart .badge {
    position: absolute;
    top: -6px;
    right: -10px;
    background: #C9D6E8;
    color: #2D2D2D;
    font-size: 10px;
    font-weight: 700;
    padding: 3px 6px;
    border-radius: 10px;
  }
  .mobile-tabbar {
    position: fixed;
    left: 0;
    right: 0;
    width: 100vw;
    bottom: 0;
    height: 64px;
    background: #FFFFFF;
    border-top: 1px solid rgba(28, 42, 70, 0.1);
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    z-index: 20;
    box-shadow: 0 -4px 20px rgba(0, 0, 0, 0.06);
  }
  .mobile-tabbar .tab {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: #9B9B9B;
    position: relative;
    font-size: 11px;
    gap: 4px;
  }
  .mobile-tabbar .tab i {
    font-size: 20px;
  }
  .mobile-tabbar .tab.router-link-active {
    color: #1C2A46;
  }
  .mobile-tabbar .tab .dot {
    position: absolute;
    right: calc(50% - 16px);
    top: 8px;
    font-size: 10px;
    color: #FFFFFF;
    background: #1C2A46;
    border-radius: 10px;
    padding: 2px 5px;
    line-height: 1;
  }
  .footer {
    border-radius: 16px 16px 0 0;
    width: 100vw;
    padding-bottom: calc(16px + 64px);
  }
  .footer-content {
    flex-direction: column;
    gap: 30px;
  }
  .footer-left, .footer-links-group, .footer-right {
    max-width: 100%;
    flex: auto;
  }
  .footer-links-group {
    justify-content: space-between;
  }
}

/* 抽屉菜单样式（小屏专用） */
@media (max-width: 900px) {
  .mobile-drawer {
    background: #F8FAFC !important;
  }
  .mobile-drawer .el-drawer__body {
    padding: 0;
    background: #F8FAFC;
    color: #2D2D2D;
  }
  .mobile-drawer-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px 20px;
    border-bottom: 1px solid rgba(28, 42, 70, 0.1);
    font-weight: 600;
    color: #FFFFFF;
    background: linear-gradient(135deg, #1C2A46 0%, #0A1837 100%);
  }
  .mobile-drawer-header i {
    font-size: 20px;
    cursor: pointer;
    color: #FFFFFF;
  }
  .mobile-drawer-body {
    padding: 16px 20px 32px;
    background: #F8FAFC;
  }
  .mobile-search {
    margin-bottom: 16px;
  }
  .mobile-search >>> .el-input__inner {
    background: #FFFFFF;
    border: 1.5px solid rgba(28, 42, 70, 0.15);
    color: #2D2D2D;
  }
  .mobile-search >>> .el-input-group__append .el-button {
    background: #1C2A46;
    border: 1px solid #1C2A46;
    color: #FFFFFF;
  }
  .drawer-switch {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 10px;
    margin-bottom: 10px;
  }
  .drawer-switch .switch-btn {
    height: 42px;
    border-radius: 8px;
    background: #FFFFFF;
    color: #2D2D2D;
    font-weight: 600;
    border: 1.5px solid rgba(28, 42, 70, 0.15);
    transition: all 0.2s ease;
  }
  .drawer-switch .switch-btn.active {
    background: #1C2A46;
    color: #ffffff;
    box-shadow: none;
    border-color: #1C2A46;
  }
  .drawer-content {
    height: calc(100vh - 160px);
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
  }
  .mobile-drawer-section .section-title,
  .drawer-col .section-title {
    font-size: 12px;
    letter-spacing: 0.5px;
    color: #1C2A46;
    margin-bottom: 10px;
    text-transform: uppercase;
    font-weight: 700;
  }
  .mobile-drawer-section .link-list li a,
  .drawer-col .link-list li a {
    display: block;
    padding: 14px 0;
    border-bottom: 1px solid rgba(28, 42, 70, 0.1);
    color: #2D2D2D;
  }
  .mobile-drawer-section .link-list li a:hover {
    color: #1C2A46;
  }
  /* 两栏布局 */
  .drawer-columns {
    display: none;
  }
  .drawer-col {
    padding-right: 0;
  }
  .drawer-left {
    border-right: 0;
  }
}

/* ============== 右下角公司信息浮窗 ============== */
.company-fab {
  position: fixed;
  right: 22px;
  bottom: 22px;
  z-index: 999;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 12px;
  pointer-events: none;
}
.company-fab > * {
  pointer-events: auto;
}

.company-fab-btn {
  width: 132px;
  height: 48px;
  border-radius: 24px;
  border: none;
  background: linear-gradient(135deg, #1C2A46 0%, #0A1837 100%);
  color: #ffffff;
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0.3px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 0 18px;
  box-shadow: 0 10px 24px rgba(28, 42, 70, 0.35), 0 2px 6px rgba(0, 0, 0, 0.08);
  transition: transform 0.2s ease, box-shadow 0.2s ease, background 0.2s ease;
}
.company-fab-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 14px 32px rgba(28, 42, 70, 0.45), 0 4px 10px rgba(0, 0, 0, 0.1);
}
.company-fab-btn:active {
  transform: translateY(0);
}
.company-fab-btn.is-active {
  background: linear-gradient(135deg, #0A1837 0%, #1C2A46 100%);
}
.company-fab-btn i {
  font-size: 18px;
  line-height: 1;
}
.company-fab-label {
  white-space: nowrap;
}

.company-card {
  width: 320px;
  max-width: calc(100vw - 32px);
  background: #ffffff;
  border-radius: 16px;
  box-shadow: 0 18px 40px rgba(28, 42, 70, 0.18), 0 4px 12px rgba(0, 0, 0, 0.08);
  overflow: hidden;
  border: 1px solid rgba(28, 42, 70, 0.12);
}

.company-card-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 18px;
  background: linear-gradient(135deg, #1C2A46 0%, #0A1837 100%);
  color: #ffffff;
}
.company-card-title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0.4px;
  text-transform: uppercase;
}
.company-card-icon {
  font-size: 16px;
}
.company-card-close {
  cursor: pointer;
  font-size: 18px;
  opacity: 0.85;
  transition: opacity 0.2s ease;
}
.company-card-close:hover {
  opacity: 1;
}

.company-card-body {
  padding: 14px 18px;
  max-height: 60vh;
  overflow-y: auto;
}
.company-card-name {
  font-size: 16px;
  font-weight: 700;
  color: #1C2A46;
  margin-bottom: 12px;
  letter-spacing: 0.3px;
}
.company-card-row {
  display: flex;
  gap: 10px;
  padding: 8px 0;
  border-bottom: 1px dashed rgba(28, 42, 70, 0.12);
  align-items: flex-start;
}
.company-card-row:last-child {
  border-bottom: 0;
}
.company-card-label {
  flex-shrink: 0;
  font-size: 12px;
  font-weight: 600;
  color: #2D2D2D;
  min-width: 78px;
  letter-spacing: 0.2px;
}
.company-card-value {
  flex: 1;
  font-size: 13px;
  color: #2D2D2D;
  line-height: 1.5;
  word-break: break-word;
}
.company-card-value.link {
  color: #1C2A46;
  text-decoration: none;
  transition: color 0.2s ease;
}
.company-card-value.link:hover {
  color: #0A1837;
  text-decoration: underline;
}

.company-card-foot {
  padding: 10px 18px;
  background: #F8FAFC;
  text-align: center;
  font-size: 11px;
  color: #6B6B6B;
  letter-spacing: 0.3px;
  border-top: 1px solid rgba(28, 42, 70, 0.1);
}

/* 浮窗展开/收起动画 */
.company-card-fade-enter-active,
.company-card-fade-leave-active {
  transition: opacity 0.25s ease, transform 0.25s ease;
}
.company-card-fade-enter,
.company-card-fade-leave-to {
  opacity: 0;
  transform: translateY(8px) scale(0.98);
}

/* 移动端隐藏该浮窗，避免遮挡 tabbar */
@media (max-width: 900px) {
  .company-fab {
    display: none;
  }
}
</style>
